export const environment = {
	'PRODUCTION': true,
	'SEXTANT': false
};
